import { CORE_STYLES } from "./StringDevCoreStyles.css";
export type StringDevStyleTokens = Record<string, string>;

const STRING_DEV_DEFAULT_TOKENS: StringDevStyleTokens = {
  "--string-dev-panel-bg": "#ffffff",
  "--string-dev-panel-border": "1px solid #e0e0e0",
  "--string-dev-panel-radius": "16px",
  "--string-dev-panel-shadow": "0 16px 24px rgba(0, 0, 0, 0.1)",
  "--string-dev-panel-backdrop": "blur(12px)",
  "--string-dev-panel-padding": "4px",
  "--string-dev-panel-font-family":
    '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  "--string-dev-panel-font-size": "12px",
  "--string-dev-panel-text": "#111111",
  "--string-dev-panel-muted": "rgba(17, 17, 17, 0.6)",
  "--string-dev-panel-subtle": "rgba(17, 17, 17, 0.72)",
  "--string-dev-panel-divider": "rgba(17, 17, 17, 0.08)",
  "--string-dev-header-font-size": "10px",
  "--string-dev-header-font-weight": "500",
  "--string-dev-header-letter-spacing": "0",
  "--string-dev-header-padding": "8px 8px 8px",
  "--string-dev-header-margin-bottom": "4px",
  "--string-dev-accent": "#FF4F36",
  "--string-dev-accent-soft": "rgba(255, 79, 54, 0.12)",
  "--string-dev-accent-soft-hover": "rgba(255, 79, 54, 0.18)",
  "--string-dev-focus-color": "rgba(255, 79, 54, 0.68)",
  "--string-dev-focus-shadow": "0 0 0 2px rgba(255, 79, 54, 0.18)",
  "--string-dev-field-bg": "rgba(221, 221, 221, 0.4)",
  "--string-dev-field-border": "rgba(255, 255, 255, 0.96)",
  "--string-dev-field-radius": "8px",
  "--string-dev-input-height": "32px",
  "--string-dev-button-height": "32px",
  "--string-dev-chip-size": "24px",
  "--string-dev-icon-button-size": "20px",
  "--string-dev-icon-button-radius": "8px",
  "--string-dev-chip-active-bg": "rgba(221, 221, 221, 0.54)",
  "--string-dev-chip-muted": "rgba(17, 17, 17, 0.22)",
  "--string-dev-chip-resolved": "rgba(17, 17, 17, 0.78)",
  "--string-dev-icon-button-hover-bg": "rgba(17, 17, 17, 0.08)",
};

function indentCss(cssText: string, indent: string): string {
  return cssText
    .trim()
    .split("\n")
    .map((line) => `${indent}${line}`)
    .join("\n");
}

export function buildDevtoolsThemeBlock(
  selectors: string | string[],
  overrides: StringDevStyleTokens = {},
): string {
  const selectorText = Array.isArray(selectors) ? selectors.join(",\n") : selectors;
  const tokens = { ...STRING_DEV_DEFAULT_TOKENS, ...overrides };
  const declarations = Object.entries(tokens)
    .map(([name, value]) => `${name}: ${value};`)
    .join("\n");

  return `${selectorText} {\n${indentCss(declarations, "  ")}\n}`;
}

export function ensureStringDevtoolsSharedStyles(): HTMLStyleElement | null {
  if (typeof document === "undefined") {
    return null;
  }

  const styleId = "string-devtools-shared-styles";
  const existing = document.getElementById(styleId);
  if (existing instanceof HTMLStyleElement) {
    return existing;
  }

  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = CORE_STYLES;
  document.head.appendChild(style);
  return style;
}
